import isArray from 'lodash/isArray';

import { OptionGroupProps } from '../Select';
import { SelectOption } from '../blocks/Option/Option';
import { isOptionGroup } from './helpers';
import { SelectMultipleValue, SelectSingleValue } from './types';

export const getActiveOrFirstOption = <Option extends SelectOption>(
  options: (OptionGroupProps | Option)[],
  value: SelectSingleValue | SelectMultipleValue
) => {
  let activeOrFirstOption: Option;
  let activeIndex: number;

  options.find((option, index) => {
    if (!isOptionGroup(option)) {
      activeOrFirstOption = activeOrFirstOption ? activeOrFirstOption : option;
      activeIndex = typeof activeIndex !== 'undefined' ? activeIndex : index;

      const isActiveOption = isArray(value) ? value.includes(option.value) : option.value === value;

      if (isActiveOption) {
        activeOrFirstOption = option;
        activeIndex = index;

        return true;
      }
    }

    return false;
  });

  return { option: activeOrFirstOption!, index: activeIndex! };
};
